<div class="container-fluid">
  <app-header titleText="Job Cost Report" i18n-titleText>
    <div button class="float-right">
      <div *ngIf="!isRequesting">
        <button type="button" class="btn btn-bidit-navigate mr-1" (click)="showParameters()" i18n>Update Filters</button>
        <button *ngIf="report" type="button" class="btn btn-bidit-navigate" (click)="renderReport()" i18n>Export</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </app-header>

  <div *ngIf="report == null" class="container">
    <div class="row">
      <h5 class="col-sm-12" i18n>Please provide report criteria</h5>
    </div>
  </div>
  <div *ngIf="report">
    <div class="row header-text">

      <div class="col-md-4">
        <app-dealer-logo></app-dealer-logo>
      </div>
      <div class="col-md-6 filter-zone">
          <p>
              <span i18n>REPORT DEFINED:</span><br />
              <ng-template [ngIf]="parameters.startDate"><span i18n>Date Range:</span> {{parameters.startDate | date: 'M/d/yyyy'}} - {{parameters.endDate | date: 'M/d/yyyy'}}<br /></ng-template>
              <ng-template [ngIf]="customer"><span i18n>Customer:</span> {{customer.customer_BusinessName}}<br /></ng-template>
              <ng-template [ngIf]="job"><span i18n>Job:</span> {{job.quote_Name}}<br /></ng-template>
          </p>
      </div>

    </div>

    <div class="content">
      <div class="quote-month-summary">
        <h2 i18n>Job Cost</h2>
        <div>
          <table class="table table-bidit">
            <thead>
              <tr>
                <th i18n>Area</th>
                <th i18n>Sub Area</th>
                <th i18n>Item</th>
                <th i18n>Bid Labor</th>
                <th i18n>Actual Labor</th>
                <th i18n>Bid Sqr Ftg</th>
                <th i18n>Actual Sqr Ftg</th>
                <th i18n>Bid Item Usage</th>
                <th i18n>Actual Usage</th>
                <th i18n>Item Cost</th>
                <th i18n>Bid Material</th>
                <th i18n>Actual Material</th>
                <th i18n>Cost Delta</th>
                <th i18n>Bid Material/Labor Total</th>
                <th i18n>Actual Material/Labor Total</th>
              </tr>
            </thead>
            <tbody>
              <ng-template ngFor let-aggregate [ngForOf]="report.aggregates">
                <tr>
                  <td colspan="14">{{aggregate.quote_Name}}</td>
                  <td>
                    <a routerLink="/quote/{{aggregate.quote_ID}}" class="btn btn-bidit-submit" i18n>View</a>
                  </td>
                </tr>
                <tr *ngFor="let jobCost of aggregate.details">
                  <td>{{jobCost.area_Name}}</td>
                  <td>{{jobCost.subArea_Name}}</td>
                  <td>{{jobCost.item_Name}}</td>
                  <td>
                    <ng-template [ngIf]="jobCost.area_TotalLaborCost">
                      ${{jobCost.area_TotalLaborCost | number: '1.2-2'}}
                    </ng-template>
                  </td>
                  <td>
                  </td>
                  <td>{{jobCost.area_SqrFtg}}</td>
                  <td>{{jobCost.area_ActualSqrFtg}}</td>
                  <td>{{jobCost.area_BidItemUsage | number: '1.0-2'}}</td>
                  <td>{{jobCost.area_ActualItemUsage | number: '1.0-2' }}</td>
                  <td>${{jobCost.item_Cost | number: '1.2-2'}}</td>
                  <td>
                    <ng-template [ngIf]="jobCost.materialBid">
                      ${{jobCost.materialBid | number: '1.2-2'}}
                    </ng-template>
                  </td>
                  <td>
                    <ng-template [ngIf]="jobCost.materialCost">
                      ${{jobCost.materialCost | number: '1.2-2'}}
                    </ng-template>
                  </td>
                  <td>
                    <ng-template [ngIf]="jobCost.usageDelta">
                      ${{jobCost.usageDelta | number: '1.2-2'}}
                    </ng-template>
                  </td>
                  <td>
                  </td>
                  <td>
                  </td>
                </tr>
                <tr class="log-summary-row">
                  <td colspan="3">
                    {{aggregate.quote_Name}} <span i18n>Totals</span>
                  </td>
                  <td>
                    <ng-template [ngIf]="aggregate.area_TotalLaborCost">
                      ${{aggregate.area_TotalLaborCost | number: '1.2-2'}}
                    </ng-template>
                  </td>
                  <td>
                    <ng-template [ngIf]="aggregate.actualLaborCost">
                      ${{aggregate.actualLaborCost | number: '1.2-2'}}
                    </ng-template>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <ng-template [ngIf]="aggregate.materialBid">
                      ${{aggregate.materialBid | number: '1.2-2'}}
                    </ng-template>
                  </td>
                  <td>
                    <ng-template [ngIf]="aggregate.materialCost">
                      ${{aggregate.materialCost | number: '1.2-2'}}
                    </ng-template>
                  </td>
                  <td>
                    <ng-template [ngIf]="aggregate.usageDelta">
                      ${{aggregate.usageDelta | number: '1.2-2'}}
                    </ng-template>
                  </td>
                  <td>
                    <ng-template [ngIf]="aggregate.bidTotal">
                      ${{aggregate.bidTotal | number: '1.2-2'}}
                    </ng-template>
                  </td>
                  <td>
                    <ng-template [ngIf]="aggregate.actualTotal">
                      ${{aggregate.actualTotal | number: '1.2-2'}}
                    </ng-template>
                  </td>
                </tr>
                <tr class="log-summary-row">
                  <td colspan="11">                   
                  </td>
                  <td class="bidit-header" >
                   <span i18n> Bid Total</span>
                  </td>
                  <td>
                    <ng-template [ngIf]="aggregate.quote_BidAmount">
                      ${{aggregate.quote_BidAmount | number: '1.2-2'}}
                    </ng-template>
                  </td>
                  <td>
                    <ng-template [ngIf]="aggregate.bidTotal">
                      ${{aggregate.quote_BidAmount - aggregate.bidTotal | number: '1.2-2'}}
                    </ng-template>
                  </td>
                  <td>
                    <ng-template [ngIf]="aggregate.actualTotal">
                      ${{aggregate.quote_BidAmount - aggregate.actualTotal | number: '1.2-2'}}
                    </ng-template>                   
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
